import ReviewsList from './ReviewsList.vue'

export default ReviewsList
